import React from 'react';

type EditIconProps = {
  onClick: () => void;
}

export default (props: EditIconProps) => (
  <svg
    onClick={props.onClick ? props.onClick : undefined}
    width="22"
    height="19"
    viewBox="0 0 22 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_79:69)">
      <path
        d="M14.9291 12.8018L16.1166 11.6143C16.3021 11.4288 16.625 11.5586 16.625 11.8258V17.2215C16.625 18.2049 15.8271 19.0028 14.8438 19.0028H1.78125C0.797852 19.0028 0 18.2049 0 17.2215V4.15903C0 3.17563 0.797852 2.37778 1.78125 2.37778H11.9307C12.1941 2.37778 12.3277 2.69692 12.1422 2.88618L10.9547 4.07368C10.899 4.12935 10.8248 4.15903 10.7432 4.15903H1.78125V17.2215H14.8438V13.0096C14.8438 12.9317 14.8734 12.8575 14.9291 12.8018ZM20.7404 5.31313L10.9955 15.0581L7.64082 15.4292C6.66855 15.5368 5.84102 14.7167 5.94863 13.737L6.31973 10.3823L16.0646 0.637353C16.9145 -0.212451 18.2875 -0.212451 19.1336 0.637353L20.7367 2.24048C21.5865 3.09028 21.5865 4.46704 20.7404 5.31313ZM17.074 6.45981L14.918 4.30376L8.02305 11.2024L7.75215 13.6256L10.1754 13.3547L17.074 6.45981ZM19.4787 3.5022L17.8756 1.89907C17.7234 1.74692 17.4748 1.74692 17.3264 1.89907L16.1797 3.04575L18.3357 5.20181L19.4824 4.05513C19.6309 3.89927 19.6309 3.65435 19.4787 3.5022Z"
        fill="#BDBDBD"
      />
    </g>
    <defs>
      <clipPath id="clip0_79:69">
        <rect width="21.375" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
